export default [
    {
        value: "EmCriacao",
        text: "Em criação"
    },
    {
        value: "ProjetoEnviadoAANEEL",
        text: "Projeto enviado á AANEEL"
    },
    {
        value: "ComprovanteProjetoArmazenado",
        text: "Comprovante do projeto armazenado"
    },
    {
        value: "InicioEnviadoAANEEL",
        text: "Início enviado á AANEEL"
    },
    {
        value: "ProjetoIniciado",
        text: "Projeto iniciado"
    },
    {
        value: "ElaborarRelatoriosFinais",
        text: "Elaborar relatórios finais"
    },
    {
        value: "FaseFinal",
        text: "Fase final"
    },
    {
        value: "PDFRelatorioFinalEnviadoAANEEL",
        text: "PDF relatório final enviado á AANEEL"
    },
    {
        value: "XMLRelatorioFinalEnviadoAANEEL",
        text: "XML relatório final enviado á AANEEL"
    },
    {
        value: "ComprovanteRelatorioFinalPDFArmazenado",
        text: "Comprovante relatório final PDF armazenado"
    },
    {
        value: "ComprovanteRelatorioFinalXMLArmazenado",
        text: "Comprovante relatório final XML armazenado"
    },
    {
        value: "PDFRelatorioAuditoriaEnviadoAANEEL",
        text: "PDF relatório auditoria enviado á AANEEL"
    },
    {
        value: "XMLRelatorioAuditoriaEnviadoAANEEL",
        text: "XML relatório auditoria enviado á AANEEL"
    },
    {
        value: "ComprovanteRelatorioAuditoriaPDFArmazenado",
        text: "Comprovante relatório auditoria PDF armazenado"
    },
    {
        value: "ComprovanteRelatorioAuditoriaXMLArmazenado",
        text: "Comprovante relatório auditoria XML armazenado"
    },
    {
        value: "ProjetoEncerrado",
        text: "Projeto encerrado"
    },
    {
        value: "ParecerANEELEmAtraso",
        text: "Parecer AANEEL em atraso"
    },
    {
        value: "RecebeuGlosaProjetoEmDefesa",
        text: "Recebeu glosa do projeto em defesa"
    },
    {
        value: "DefesaEnviadaAANEEL",
        text: "Defesa enviada á AANEEL"
    },
    {
        value: "ProjetoAprovadoEFinalizado",
        text: "Projeto aprovado e finalizado"
    }
]